import { Stack, Text } from "@chakra-ui/react";
import { useTextVariants } from "@/theme/components/useSectionHeading";
import Vmware from "public/privateCloud/vmware-cloud.jpg";

type DescCompProps = {
  description: string[];
};

const DescComp = (props: DescCompProps) => {
  const TextVariant = useTextVariants();
  const { description } = props;
  return (
    <Stack spacing={2}>
      {description.map((desc, index) => (
        <Text key={index} variant={TextVariant} color="text.100">
          {desc}
        </Text>
      ))}
    </Stack>
  );
};

export const INTRO_CONSTANTS = {
  heading: "VMware Cloud  - Comprehensive suite of cloud computing services",
  description: (
    <DescComp
      description={[
        "OneMind transforms the VMware Cloud experience into a truly virtual-first, fully managed journey—where agility meets simplicity. Built on VMware’s rock-solid infrastructure, our platform empowers you to build, run, and secure applications across any cloud environment with consistency and control.",
        "Whether you're operating in private, public, or hybrid clouds, OneMind abstracts the complexity—delivering seamless integration, automated scalability, and unified operations without the weight of traditional infrastructure.",
        "It’s not just VMware Cloud. It’s VMware Cloud, reimagined by OneMind—delivered as a service, optimized for scale, and managed end-to-end so your teams can focus on what matters most.",
      ]}
    />
  ),
  points: [
    "Effortless migration to cloud ",
    "Advanced automation for cloud-native applications ",
    "Industry-leading security and compliance ",
  ],
  image: Vmware,
};
